module.exports = __webpack_public_path__ + "zuerich.svg?05c80918843cab197c9efa792ad14176";